import { Document } from "@daytrip/legacy-models";
import { isUndefinedOrNull } from "@daytrip/utils";
import autobind from "autobind-decorator";
import { action, observable } from "mobx";

import { ModelOperator } from "./ModelOperator";

@autobind
export class DocumentOperator extends ModelOperator<Document, {}, null, null, null> {
    @observable
    public documentDeclinationReason?: string;

    @observable
    public documentIssueAt?: Date;

    @observable
    public documentExpiryAt?: Date;

    public constructor(options: any) {
        super(options);
        this.documentIssueAt = this.m.issueAt;
        this.documentExpiryAt = this.m.expiryAt;
    }

    @action
    public onChangeDeclinationReason(value: string) {
        this.documentDeclinationReason = value;
    }

    @action
    public onChangeIssueAt(value: Date | undefined) {
        this.documentIssueAt = value;
    }

    @action
    public onChangeExpiryDate(value: Date | undefined) {
        this.documentExpiryAt = value;
    }

    @action
    public async approveDocument() {
        try {
            this.m.issueAt = this.documentIssueAt;
            this.m.expiryAt = this.documentExpiryAt;

            this.model = await this.rpcClient.driver.approveDocument(this.m._id, this.documentExpiryAt);
        } catch (e: any) {
            alert("Oh, something got wrong. :(");
        }
    }

    @action
    public async declineDocument() {
        if (isUndefinedOrNull(this.documentDeclinationReason) || this.documentDeclinationReason == "") {
            alert("Please write some declination reason.");
            return;
        }

        try {
            this.model = await this.rpcClient.driver.declineDocument(this.m._id, this.documentDeclinationReason);
            this.documentDeclinationReason = undefined;
        } catch (e: any) {
            alert("Oh, something got wrong. :(");
        }
    }
}
